import React from 'react';
import classnames from 'classnames';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { PrimaryToolTip } from '../../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { ReactComponent as AccountIcon } from '../../../../../../../../layout/BotBuilderSidebar/UserDropdown/UserDropdownIcons/UserFallback.svg';
import { useConnectSlack } from './use-connect-slack';
import { LinkOutlined, TeamOutlined } from '@ant-design/icons';
import { SlackAccount } from '@mm/state/model/SlackModel';
import { selectCrmsLeadsSent } from '@mm/state/selectors/connectionsSelectors';
import { useSelector } from 'react-redux';
import { Tooltip } from '@mm/components';

type Props = {
  accountsCount: number;
  connectionsCount: number;
  addNewConnection: (slackAccount?: SlackAccount) => void;
  className?: string;
};

export const SlackHeaderComponent = (props: Props) => {
  const { accountsCount, className, connectionsCount, addNewConnection } =
    props;

  const { connectSlack } = useConnectSlack();

  const onAddAccountClick = () => {
    connectSlack();
  };

  const crmsLeadsSent = useSelector(selectCrmsLeadsSent);
  const leadsSent = crmsLeadsSent?.slackContactsSent;

  const headerClassname = classnames(className, {
    'integrations__header--account-connected': !!accountsCount,
  });

  return (
    <div className={headerClassname}>
      <div className="integrations__header-actions">
        <Tooltip title="Slack Accounts used in connections" placement="bottom">
          {!!accountsCount && (
            <div className="integrations__header-status">
              <AccountIcon className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">
                {accountsCount}
              </div>
              Accounts
            </div>
          )}
        </Tooltip>
        {accountsCount && (
          <>
            <div className="integrations__header-status">
              <LinkOutlined className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">
                {connectionsCount}
              </div>
              Connections
            </div>
            {!!leadsSent && (
              <div className="integrations__header-status">
                <TeamOutlined className="integrations__header-status-icon" />
                <div className="integrations__header-status-count">
                  {leadsSent}
                </div>
                Leads sent
              </div>
            )}
          </>
        )}

        <PrimaryButton
          className="integrations__header-add-button-secondary"
          onClick={e => {
            e?.stopPropagation();
            onAddAccountClick();
          }}
          color={ButtonColor.secondaryBlue}
        >
          Add an Account
        </PrimaryButton>

        {accountsCount && (
          <PrimaryButton
            className="integrations__header-add-button-secondary"
            onClick={e => {
              e?.stopPropagation();
              addNewConnection();
            }}
            color={ButtonColor.secondaryBlue}
          >
            Add a Connection
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};
